import {observable, action, runInAction} from 'mobx'
import {json} from '../../../../utils/ajax'
import {handleSearchAndPage, setStore, ValueObjToObj} from "../../../../utils/Utils";
import {message} from "antd";

class partInformationChangeStore {
    @observable list   //总成散件列表
    @observable loading //列表loading
    @observable pagination //总成散件库分页
    @observable searchFiles //主页面搜索值绑定
    @observable addFields//新增模态框字段
    @observable addVisible//新增模态框
    @observable addType//判断新增类型
    @observable addLoading//判断新增类型
    @observable importReturnData //导入返回值
    @observable showDrawer

    constructor() {
        this.list = []
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchField = {
            carMaterialCode:'',
            materialCode:'',
            vin:'',
            changeStatus:''
        }
        this.addFields = {
            carMaterialCode:'',
            materialCode:'',
            vin:'',
            changeStatus:''  //变更状态: Y、启用, N、停用
        }
        this.addVisible = false
        this.addLoading = false
        this.addType=''
        this.importReturnData = []
        this.showDrawer = false


    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields,field) => {
        const change = ValueObjToObj(changedFields)
        this[field] = {...this[field], ...change}
    }

    /** 右侧总成列表**/
    @action
    initPage = async (page) => {
        this.loading = true
        let searchField = {
            carMaterialCode:this.searchField.carMaterialCode ? this.searchField.carMaterialCode :'',
            materialCode:this.searchField.materialCode ? this.searchField.materialCode :'',
            vin:this.searchField.vin ? this.searchField.vin :''
        };
        console.log(searchField,'searchField------')
        let search = handleSearchAndPage(page, this.pagination,searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/partInformationChange:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.list = res ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /***保存新增**/
    @action
    saveAddModal = async (content) => {
        this.addLoading=true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/partInformationChange/add`, content)
        if (res.status !== 0) {
            runInAction(() => {
                this.addVisible = false
                this.addLoading = false
            })
            message.success('新增成功')
            this.initPage(this.pagination.current)
        }
    }

    /***删除**/
    @action
    deleteRow = async (id) => {
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/partInformationChange/delById/id/${id}`)
        if (res.status !== 0) {
            message.success('删除成功')
            this.initPage(this.pagination.current)
        }
    }

    /** 开启抽屉 **/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }


    /** 关闭抽屉 **/
    @action
    onClose = () => {
        this.showDrawer = false
    }


}

export default new partInformationChangeStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sbom/PartInformationChange/store.js